import { LoadingButton } from "@mui/lab";
import { TextField } from "@mui/material";
import { UserContext } from "contexts/UserContext/UserContext";
import React, { useContext, useState } from "react";

export const Login = () => {
  const { login, error, isLoading } = useContext(UserContext);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  return (
    <div className="layout-login">
      <TextField label="Username" value={username} onChange={(e) => setUsername(e.target.value)} error={!!error} />
      <TextField label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} error={!!error} />
      <LoadingButton variant="contained" loading={isLoading} onClick={() => login(username, password)}>
        Login
      </LoadingButton>
    </div>
  );
};
